import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

export const RaceRunnerInfo = withConfig(theme => styled('div', { label: 'RaceRunnerInfo' })`
    display: flex;
    flex-flow: column nowrap;
    @media ${theme.star.mediaQuery.tablet} {
        flex: 0 0 50%;
    }
`);

const setTextTruncate = (textTruncate: boolean): SerializedStyles => {
    if (textTruncate) {
        return css`
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        `;
    }
    return css`
        overflow-wrap: anywhere;
        word-break: break-word;
    `;
};

interface RunnerNameAndPlaceType {
    textTruncate: boolean;
    variant: DefaultComponentVariantType | null
}

export const RunnerNameAndPlace = withConfig(theme => styled('div', { label: 'RunnerNameAndPlace' })<RunnerNameAndPlaceType>`
    ${({ textTruncate }): SerializedStyles => setTextTruncate(textTruncate)};
    color: ${theme.star.raceSummary.txtColor};
    font-size: ${({ variant }) => (variant === DefaultComponentVariantType.TERTIARY ? theme.star.unified.racingNextOff : theme.star).raceSummary.typography.fontSizePrimary};
    line-height: ${({ variant }) => (variant === DefaultComponentVariantType.TERTIARY ? theme.star.unified.racingNextOff : theme.star).raceSummary.typography.lineHeightPrimary};
    font-weight: ${({ variant }) => (variant === DefaultComponentVariantType.TERTIARY ? theme.star.unified.racingNextOff : theme.star).raceSummary.typography.fontWeightPrimary};

    & + [class$='RunnerDetailsWrapper'] {
        color: ${({ variant }) => (variant === DefaultComponentVariantType.TERTIARY ? theme.star.unified.racingNextOff : theme.star).raceSummary.txtColorSecondary};
    }
`);

interface RunnerDetailsWrapperType {
    textTruncate: boolean;
}

export const RunnerDetailsWrapper = withConfig(theme => styled('div', { label: 'RunnerDetailsWrapper' }) <RunnerDetailsWrapperType>`
    ${({ textTruncate }): SerializedStyles => setTextTruncate(textTruncate)};
    color: ${theme.star.raceSummary.txtColorSecondary};
    font-size: ${theme.star.raceSummary.typography.fontSizeSecondary};
    line-height: ${theme.star.raceSummary.typography.lineHeightSecondary};
    width: 100%;
`);

export const RunnerDetails = styled('i', { label: 'RunnerDetails' })`
    font-style: normal;
    position: relative;
    &::after {
        content: '•';
        margin: 0 4px;
    }
    &:last-of-type {
        &::after {
            content: none;
        }
    }
`;

export const RunnerDetailsNumber = styled(RunnerDetails, { label: 'RunnerDetailsNumber' })` 
    margin-right: 2px;
    &::after {
        content: none;
    }
`;
